import { render, staticRenderFns } from "./passStartQuset.vue?vue&type=template&id=757603e0&scoped=true&"
import script from "./passStartQuset.vue?vue&type=script&lang=js&"
export * from "./passStartQuset.vue?vue&type=script&lang=js&"
import style0 from "./passStartQuset.vue?vue&type=style&index=0&id=757603e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757603e0",
  null
  
)

export default component.exports